import React, { Component } from 'react';
import "./oversizedSideBySideQuote.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    return (
      <div className={`row ${ this.props.direction }`}>
        <div className="small-12 medium-6">
          <div className="oversized-side-by-side-quote-image">
            <img className="full-width background-image-fill hover-grow" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.image })`}} />
          </div>
        </div>
        <div className="small-12 medium-6">
          <div className="oversized-side-by-side-quote-text">
            <h1>{this.props.quote}</h1>
            <p className={'subheading'} style={{textAlign:'right'}}>{this.props.rider}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/oversizedSideBySideQuote/index.js